// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeContestMakeupWaiveBody = {
  poolId: string;
  contestId: string;
  reviewToken: string;
  requestId: string;
  reason: string;
};

export type typeContestMakeupWaiveOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { waiverId: string; waivedPickCount: number };
};

export type typeContestMakeupWaiveOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestMakeupWaiveOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestMakeupWaiveOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaContestMakeupWaiveBody = {
  type: "object",
  properties: {
    poolId: { type: "string", minLength: 1, maxLength: 3000 },
    contestId: { type: "string", minLength: 1, maxLength: 3000 },
    reviewToken: { type: "string", minLength: 1, maxLength: 3000 },
    requestId: { type: "string", minLength: 1, maxLength: 3000 },
    reason: { type: "string", minLength: 1, maxLength: 3000 },
  },
  required: ["poolId", "contestId", "reviewToken", "requestId", "reason"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createContestMakeupWaive(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaContestMakeupWaiveBody);
  }

  return async function postContestMakeupWaive(
    payload: typeContestMakeupWaiveBody,
  ): Promise<
    typeContestMakeupWaiveOutput200 | typeContestMakeupWaiveOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postContestMakeupWaive" failed before calling the network. #f0e8446bef08`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#f0e8446bef08" },
        },
        data: null,
      } as typeContestMakeupWaiveOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/contest/makeup-waive`,
      httpMethod: "POST",
      options,
    })) as typeContestMakeupWaiveOutput200 | typeContestMakeupWaiveOutput400;
  };
}
